import React, { useRef, useEffect, useState, useCallback, useMemo } from 'react';
import styles from './App.css'; // Corrected import for CSS Modules
import { INITIAL_POI_DATA } from './data.js'

// Combined POI data


const translations = {
    // New Category Translations
    'Spider': { en: 'Spider', fr: 'Araignée' },
    'Toy Postcard': { en: 'Toy Postcard', fr: 'Le Voyage de Token' },
    'Fallen Star': { en: 'Fallen Star', fr: 'Étoiles' },
    "Catherine's Memories": { en: "Catherine's Memories", fr: 'Souvenirs de Catherine' },
    "Miniature Donkey": { en: "Miniature Donkey", fr: 'Ânes Miniatures' },
    "Brissie\'s Adventures": { en: "Brissie's Adventures", fr: 'Les Aventures de Brissie' },
    'Archaeology Epona': { en: 'Archaeology Epona', fr: 'Archéologie Epona' },
    'Archaeology VHD': { en: 'Archaeology VHD', fr: 'Archéologie Vallée du Dino' },
    'Erissa\'s Dolls': { en: 'Erissa\'s Dolls', fr: 'Les Poupées d\'Erissa' },
    'Secret Quest Bee': { en: 'Secret Quest Bee', fr: 'Quête Secrète Abeille' },
    'Secret Quest Fox': { en: 'Secret Quest Fox', fr: 'Quête Secrete Renard' },
    'Plantes': { en: 'Plants', fr: 'Plantes' },

    // Loading
    loadingMap: { en: 'Loading Map Data...', fr: 'Chargement des données de la carte...' },

    // Top Bar
    ssoTitleAlt: { en: 'SSO Interactive Map', fr: 'Carte Interactive SSO' },
    dzakaLogoAlt: { en: 'Dzaka Logo', fr: 'Logo Dzaka' },
    filters: { en: 'Filters', fr: 'Filtres' },
    languageLabel: { en: 'Language', fr: 'Langue' },
    mapLabel: { en: 'Map', fr: 'Carte' },
    modeLabel: { en: 'Mode', fr: 'Mode' },
    modeColor: { en: 'Color', fr: 'Couleur' },
    modeBW: { en: 'Dark', fr: 'Sombre' },
    mapJorvik: { en: 'Jorvik', fr: 'Jorvik' },
    mapWinterVillage: { en: 'Winter Village', fr: 'Village d\'Hiver' },
    mapPandoria: { en: 'Pandoria', fr: 'Pandoria' },
    mapAideensPlaza: { en: "Aideen's Plaza", fr: "Place d'Aideen" },
    mapJorvikCityGallery: { en: "Jorvik City Gallery", fr: "Galerie Jorvik City" },
    mapGovernorsFall: { en: "Governor's Fall", fr: "Chute du Gouverneur" },
    mapPier13: { en: "Pier 13", fr: "Quai 13" },

    // Add POI Form
    addPoiTitle: { en: 'Add POI', fr: 'Ajouter un POI' },
    xCoordPlaceholder: { en: 'X Coordinate', fr: 'Coordonnée X' },
    yCoordPlaceholder: { en: 'Y Coordinate', fr: 'Coordonnée Y' },
    poiNamePlaceholder: { en: 'POI Name', fr: 'Nom du POI' },
    selectCategory: { en: 'Collectible', fr: 'Collectible' },
    createNewCategory: { en: '-- + Create a Collectible --', fr: '-- + Créer un Collectible --' },
    newCategoryNamePlaceholder: { en: 'New Category Name', fr: 'Nom de la nouvelle catégorie' },
    colorPickerTitle: { en: 'Choose a color', fr: 'Choisissez une couleur' },
    notesFrPlaceholder: { en: 'Notes (Français)', fr: 'Notes (Français)' },
    notesEnPlaceholder: { en: 'Notes (English)', fr: 'Notes (Anglais)' },
    addPoiButton: { en: 'Add POI', fr: 'Ajouter le Point d\'intérêt' },

    // Filter Panel
    filterCategoriesTitle: { en: 'Collectibles', fr: 'Collectibles' },
    manageButton: { en: 'Manage', fr: 'Gérer' },
    manageCustomCategories: { en: 'Manage Collectibles', fr: 'Gérer les Collectibles' },

    // POI Popup
    popupCategoryLabel: { en: 'Category:', fr: 'Catégorie :' },
    noDescription: { en: 'No description.', fr: 'Aucune description.' },
    markAsUnfound: { en: 'Mark as Unfound', fr: 'Marquer comme non trouvé' },
    markAsFound: { en: 'Mark as Found', fr: 'Marquer comme trouvé' },
    deleteButton: { en: 'Delete', fr: 'Supprimer' },

    // Modals
    confirmDeletePoi: { en: 'Are you sure you want to delete this POI?', fr: 'Êtes-vous sûr de vouloir supprimer ce Point d\'intérêt ?' },
    categoryNameEmpty: { en: 'Category name cannot be empty.', fr: 'Le nom de la catégorie ne peut pas être vide.' },
    newCategoryNameEmptyError: { en: 'New category name cannot be empty.', fr: 'Le nom de la nouvelle catégorie ne peut pas être vide.' },
    categoryExistsError: {
        en: (name) => `Category "${name}" already exists.`,
        fr: (name) => `La catégorie "${name}" existe déjà.`
    },
    confirmDeleteCategory: {
        en: (cat, fallback) => `Are you sure you want to delete the "${cat}" category? All POIs in this category will be deleted".`,
        fr: (cat, fallback) => `Êtes-vous sûr de vouloir supprimer la catégorie "${cat}" ? Tous les Point d\'intérêt de cette catégorie seront supprimé".`
    },
    fillFieldsError: { en: 'Please fill X, Y, Name, and Category.', fr: 'Veuillez remplir X, Y, Nom et Catégorie.' },
    cancelButton: { en: 'Cancel', fr: 'Annuler' },
    okButton: { en: 'OK', fr: 'OK' },

    // Category Manager
    updateButton: { en: 'Update', fr: 'Mettre à jour' },
    noCustomCategories: { en: 'No custom collectibles to manage.', fr: 'Aucun Collectible personnalisé à gérer.' }

};

// --- Responsive Hook ---
const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(window.matchMedia(query).matches);

    useEffect(() => {
        const media = window.matchMedia(query);
        const listener = () => setMatches(media.matches);

        media.addEventListener('change', listener);
        return () => media.removeEventListener('change', listener);
    }, [query]);

    return matches;
};


// Custom Modal component
const CustomModal = ({ message, onConfirm, onCancel, showCancel = false, language = 'en' }) => {
    return (
        <div className="modalOverlay">
            <div className="modalContent">
                <p className="modalMessage">{message}</p>
                <div className="modalActions">
                    {showCancel && (<button onClick={onCancel} className="modalButtonSecondary">{translations.cancelButton[language]}</button>)}
                    <button onClick={onConfirm} className="modalButtonPrimary">{translations.okButton[language]}</button>
                </div>
            </div>
        </div>
    );
};

const CategoryManagerModal = ({ customCategories, categoryColors, onClose, onUpdate, onDelete, language = 'en' }) => {
    const [edits, setEdits] = useState({});

    useEffect(() => {
        const initialEdits = {};
        customCategories.forEach(cat => {
            initialEdits[cat] = { name: cat, color: categoryColors[cat] || '#ffffff' };
        });
        setEdits(initialEdits);
    }, [customCategories, categoryColors]);

    const handleInputChange = (originalName, field, value) => {
        setEdits(prev => ({
            ...prev,
            [originalName]: { ...prev[originalName], [field]: value }
        }));
    };

    const getCategoryDisplayName = (category) => {
        return translations[category]?.[language] || category;
    };

    return (
        <div className="categoryManagerOverlay">
            <div className="categoryManagerContent">
                <div className="categoryManagerHeader">
                    <h2>{translations.manageCustomCategories[language]}</h2>
                    <button className="popupCloseButton" onClick={onClose}>&times;</button>
                </div>
                <div className="categoryList">
                    {customCategories.length > 0 ? customCategories.map(cat => (
                        <div key={cat} className="categoryEditRow">
                            <input
                                type="color"
                                value={edits[cat]?.color || '#ffffff'}
                                className="colorPicker"
                                onChange={(e) => handleInputChange(cat, 'color', e.target.value)}
                            />
                            <input
                                type="text"
                                placeholder={getCategoryDisplayName(cat)}
                                value={edits[cat]?.name || ''}
                                className="formInput"
                                onChange={(e) => handleInputChange(cat, 'name', e.target.value)}
                            />
                            <button className="updateButton" onClick={() => onUpdate(cat, edits[cat].name, edits[cat].color)}>{translations.updateButton[language]}</button>
                            <button className="deleteButton" onClick={() => onDelete(cat)}>{translations.deleteButton[language]}</button>
                        </div>
                    )) : <p>{translations.noCustomCategories[language]}</p>}
                </div>
            </div>
        </div>
    );
};


// --- Constants ---
const MAPS = {
    jorvik: { id: 'jorvik', nameKey: 'mapJorvik', file: 'map sso.png', width: 410, height: 410, maxScale: 10, offsetX: 0, offsetY: 0 },
    winterVillage: { id: 'winter-village', nameKey: 'mapWinterVillage', file: 'winter_village_map.jpg', width: 60, height: 60, maxScale: 50, offsetX: 0, offsetY: 0 },
    pandoria: { id: 'pandoria', nameKey: 'mapPandoria', file: 'map pandoria.jpg', width: 60, height: 60, maxScale: 50, offsetX: -598, offsetY: 132 },
    aideensPlaza: { id: 'aideens-plaza', nameKey: 'mapAideensPlaza', file: "map la place d'aideen.JPG", width: 14, height: 13, maxScale: 50, offsetX: 0, offsetY: 0 },
    jorvikCityGallery: { id: 'jorvik-city-gallery', nameKey: 'mapJorvikCityGallery', file: "map Galerie Jorvik City.JPG", width: 10, height: 10, maxScale: 50, offsetX: 0, offsetY: 0 },
    governorsFall: { id: 'governors-fall', nameKey: 'mapGovernorsFall', file: "map la chute du gouverneur.JPG", width: 19, height: 19, maxScale: 50, offsetX: 0, offsetY: 0 },
    pier13: { id: 'pier-13', nameKey: 'mapPier13', file: "map quai 13.JPG", width: 23, height: 23, maxScale: 50, offsetX: 0, offsetY: 0 }
};

const CATEGORY_ICONS = {
    'Spider': 'araignée.png',
    'Toy Postcard': 'flamme.png',
    'Fallen Star': 'etoile.png',
    "Catherine's Memories": 'papillion.png',
    "Miniature Donkey": 'fer a cheval.png',
    "Brissie's Adventures": 'brissie.png',
    'Archaeology Epona': 'amphore romain.png',
    'Archaeology VHD': 'dino mystique.png',
    'Erissa\'s Dolls': 'poupée erissa.png',
    'Secret Quest Bee': 'abeille.png',
    'Secret Quest Fox': 'renard1.png',
    'Plantes': 'camomille.png'
};

// --- Main App Component ---
const App = () => {
    // --- Refs ---
    const canvasRef = useRef(null);
    const mapImageRef = useRef(new Image());
    const patouneImageRef = useRef(new Image());
    const myrtilleImageRef = useRef(new Image());
    const beeImageRef = useRef(new Image());
    const alveoleImageRef = useRef(new Image());
    const dollImageRef = useRef(new Image());
    const brissieImageRef = useRef(new Image());
    const spiderImageRef = useRef(new Image());
    const shoeImageRef = useRef(new Image());
    const shoe2ImageRef = useRef(new Image());
    const starImageRef = useRef(new Image());
    const butterflyImageRef = useRef(new Image());
    const butterfly1ImageRef = useRef(new Image());
    const butterfly2ImageRef = useRef(new Image());
    const butterfly3ImageRef = useRef(new Image());
    const flameImageRef = useRef(new Image());
    const flame2ImageRef = useRef(new Image());
    const flame3ImageRef = useRef(new Image());
    const flame4ImageRef = useRef(new Image());
    const flame5ImageRef = useRef(new Image());
    const flame6ImageRef = useRef(new Image());
    const smallDinoImageRef = useRef(new Image());
    const uncommonDinoImageRef = useRef(new Image());
    const spectacularDinoImageRef = useRef(new Image());
    const mysticalDinoImageRef = useRef(new Image());
    const vikingSwordImageRef = useRef(new Image());
    const cutleryImageRef = useRef(new Image());
    const spyglassImageRef = useRef(new Image());
    const amphoraImageRef = useRef(new Image());
    const fox1ImageRef = useRef(new Image());
    const fox2ImageRef = useRef(new Image());
    const juteImageRef = useRef(new Image());
    const linImageRef = useRef(new Image());
    const garanceImageRef = useRef(new Image());
    const camomilleImageRef = useRef(new Image());
    const monardeImageRef = useRef(new Image());
    const mousseImageRef = useRef(new Image());
    const initialPanSet = useRef(false);
    const dragStartPos = useRef({ x: 0, y: 0 });
    const pinchDist = useRef(0);
    const categoriesInitialized = useRef(false);

    // --- State Management ---
    const [pois, setPois] = useState([]);
    const [activeTooltip, setActiveTooltip] = useState(null);
    const [language, setLanguage] = useState('fr');
    const [modal, setModal] = useState({ isVisible: false, message: '', onConfirm: () => { }, onCancel: () => { }, showCancel: false });
    const [scale, setScale] = useState(1);
    const [panX, setPanX] = useState(0);
    const [panY, setPanY] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [isPinching, setIsPinching] = useState(false);
    const [lastMousePos, setLastMousePos] = useState({ x: 0, y: 0 });
    const [currentMapId, setCurrentMapId] = useState('jorvik');
    const [mapMode, setMapMode] = useState('color');
    const [isImageLoaded, setIsImageLoaded] = useState(false);

    // --- State for Enhanced Features ---
    const [selectedPoi, setSelectedPoi] = useState(null);
    const [pinnedPoi, setPinnedPoi] = useState(null);
    const [isPoiFormMinimized, setIsPoiFormMinimized] = useState(true);
    const [allCategories, setAllCategories] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState(new Set());

    const [isFilterMinimized, setIsFilterMinimized] = useState(false);
    const [isCategoryManagerOpen, setIsCategoryManagerOpen] = useState(false);
    const [categoryColors, setCategoryColors] = useState({
        'Spider': '#3498db', 'Toy Postcard': '#e74c3c', 'Fallen Star': '#f1c40f',
        "Catherine's Memories": '#9b59b6', "Miniature Donkey": '#2ecc71', "Brissie's Adventures": '#90a0ad',
        'Archaeology Epona': ' #c99e00', 'Archaeology VHD': '#81e9ff',
        'Erissa\'s Dolls': '#ff4dc6',
        'Secret Quest Bee': '#cbff4d',
        'Secret Quest Fox': ' #ff9c00',
        'Plantes': '#27ae60'
    });

    const [newPoi, setNewPoi] = useState({ x: '', y: '', name: '', category: '', notes_en: '', notes_fr: '' });
    const [showNewCategoryInput, setShowNewCategoryInput] = useState(false);
    const [newCategoryName, setNewCategoryName] = useState('');
    const [newCategoryColor, setNewCategoryColor] = useState('#ffffff');

    // --- Responsive State ---
    const isDesktop = useMediaQuery('(min-width: 992px)');
    const visiblePois = useMemo(() => {
        const currentMap = Object.values(MAPS).find(m => m.id === currentMapId) || MAPS.jorvik;
        const filtered = pois.filter(p => p.x !== null && p.y !== null && p.mapId === currentMapId && selectedCategories.has(p.category));

        const placed = [];
        // Threshold in map units (approx equivalent to 10-15px at normal zoom)
        const thresholdMapUnits = 3.0;

        return filtered.map(p => {
            let count = 0;
            // Check against already placed points to find overlaps in MAP units within the SAME category
            for (const other of placed) {
                if (other.category !== p.category) continue;

                const dx = p.x - other.x;
                const dy = p.y - other.y;
                const distSq = dx * dx + dy * dy;

                if (distSq < thresholdMapUnits * thresholdMapUnits) {
                    count++;
                }
            }

            // Shift by a fixed amount of map units per overlap
            const shiftMapUnits = 2.0;
            const visualX = p.x + currentMap.offsetX + (count * shiftMapUnits);
            const visualY = p.y + currentMap.offsetY + (count * shiftMapUnits);

            const poiWithVisual = { ...p, groupIndex: count, visualX, visualY };
            placed.push(poiWithVisual);
            return poiWithVisual;
        });
    }, [pois, selectedCategories, currentMapId]); // Removed scale dependency to prevent jumping


    // --- Constants ---
    const BUILT_IN_CATEGORIES = ['Spider', 'Toy Postcard', 'Fallen Star', "Catherine's Memories", "Miniature Donkey", "Brissie's Adventures", 'Archaeology Epona'
        , 'Erissa\'s Dolls', 'Secret Quest Bee', 'Secret Quest Fox', 'Archaeology VHD', 'Plantes'];
    const LOCAL_STORAGE_KEY_POIS = 'ssoInteractiveMapPois';
    const LOCAL_STORAGE_KEY_CATEGORIES = 'ssoInteractiveMapCategories';
    const LOCAL_STORAGE_KEY_SELECTION = 'ssoInteractiveMapSelectedCategories';


    // --- Data Loading & Saving (useEffect) ---
    useEffect(() => {
        const storedCategoriesRaw = localStorage.getItem(LOCAL_STORAGE_KEY_CATEGORIES);
        if (storedCategoriesRaw) {
            try {
                const storedData = JSON.parse(storedCategoriesRaw);
                setCategoryColors(prev => ({ ...prev, ...storedData.colors }));
            } catch (error) { console.error("Error parsing categories:", error); }
        }

        const storedPoisRaw = localStorage.getItem(LOCAL_STORAGE_KEY_POIS);
        const storedPois = storedPoisRaw ? JSON.parse(storedPoisRaw) : [];
        const initialPoiMap = new Map(INITIAL_POI_DATA.map(p => [p.id, p]));
        const finalPois = [];
        const seenIds = new Set();
        storedPois.forEach(storedPoi => {
            const initialData = initialPoiMap.get(storedPoi.id);
            if (initialData) {
                finalPois.push({ ...initialData, isFound: storedPoi.isFound, mapId: initialData.mapId || 'jorvik' });
            } else if (storedPoi.id.startsWith('custom-poi-')) {
                finalPois.push({ ...storedPoi, mapId: storedPoi.mapId || 'jorvik' });
            }
            seenIds.add(storedPoi.id);
        });
        INITIAL_POI_DATA.forEach(initialPoi => {
            if (!seenIds.has(initialPoi.id)) {
                finalPois.push({ ...initialPoi, isFound: false, mapId: initialPoi.mapId || 'jorvik' });
            }
        });
        setPois(finalPois);

        // Load images
        patouneImageRef.current.src = 'patoune.png';
        myrtilleImageRef.current.src = 'myrtille2.png';
        beeImageRef.current.src = 'abeille.png';
        alveoleImageRef.current.src = 'alveoles.png';
        dollImageRef.current.src = 'poupée erissa.png';
        brissieImageRef.current.src = 'brissie.png';
        spiderImageRef.current.src = 'araignée.png';
        shoeImageRef.current.src = 'fer a cheval.png';
        shoe2ImageRef.current.src = 'fer a cheval2.png';
        starImageRef.current.src = 'etoile.png';
        butterflyImageRef.current.src = 'papillion.png';
        butterfly1ImageRef.current.src = 'papillion1.png';
        butterfly2ImageRef.current.src = 'papillion2.png';
        butterfly3ImageRef.current.src = 'papillion3.png';
        flameImageRef.current.src = 'flamme.png';
        flame2ImageRef.current.src = 'flamme2.png';
        flame3ImageRef.current.src = 'flamme3.png';
        flame4ImageRef.current.src = 'flamme4.png';
        flame5ImageRef.current.src = 'flamme5.png';
        flame6ImageRef.current.src = 'flamme6.png';
        smallDinoImageRef.current.src = 'petit dino.png';
        uncommonDinoImageRef.current.src = 'dino peu commun.png';
        spectacularDinoImageRef.current.src = 'dino spectaculaire.png';
        mysticalDinoImageRef.current.src = 'dino mystique.png';
        vikingSwordImageRef.current.src = 'epee viking.png';
        cutleryImageRef.current.src = 'fourchette.png';
        spyglassImageRef.current.src = 'longue vue.png';
        amphoraImageRef.current.src = 'amphore romain.png';
        fox1ImageRef.current.src = 'renard1.png';
        fox2ImageRef.current.src = 'renard2.png';
        juteImageRef.current.src = 'jute.png';
        linImageRef.current.src = 'lin.png';
        garanceImageRef.current.src = 'garance des teinturiers.png';
        camomilleImageRef.current.src = 'camomille.png';
        monardeImageRef.current.src = 'monarde.png';
        mousseImageRef.current.src = 'mousse.png';
    }, []);

    useEffect(() => {
        if (pois.length === 0) {
            return;
        }

        const categoriesFromPois = new Set(pois.map(p => p.category));
        const allKnownCategories = Array.from(new Set([...Object.keys(categoryColors), ...categoriesFromPois]));
        setAllCategories(allKnownCategories);

        if (!categoriesInitialized.current) {
            const storedSelectionRaw = localStorage.getItem(LOCAL_STORAGE_KEY_SELECTION);

            if (storedSelectionRaw !== null) {
                try {
                    setSelectedCategories(new Set(JSON.parse(storedSelectionRaw)));
                } catch (e) {
                    console.error("Failed to parse stored categories, defaulting to all.", e);
                    setSelectedCategories(new Set(allKnownCategories)); // Fallback
                }
            } else {
                setSelectedCategories(new Set(allKnownCategories));
            }

            categoriesInitialized.current = true;
        }
    }, [pois, categoryColors]);

    useEffect(() => {
        if (pois.length > 0) {
            try {
                const serializablePois = pois.map(poi => poi.id.startsWith('custom-poi-') ? poi : { id: poi.id, isFound: poi.isFound });
                localStorage.setItem(LOCAL_STORAGE_KEY_POIS, JSON.stringify(serializablePois));

                const customColors = {};
                for (const category in categoryColors) {
                    if (!BUILT_IN_CATEGORIES.includes(category)) {
                        customColors[category] = categoryColors[category];
                    }
                }
                localStorage.setItem(LOCAL_STORAGE_KEY_CATEGORIES, JSON.stringify({ colors: customColors }));
            } catch (error) { console.error("Error saving data:", error); }
        }
    }, [pois, categoryColors]);

    useEffect(() => {
        if (categoriesInitialized.current) {
            try {
                localStorage.setItem(LOCAL_STORAGE_KEY_SELECTION, JSON.stringify(Array.from(selectedCategories)));
            } catch (error) {
                console.error("Error saving category selection:", error);
            }
        }
    }, [selectedCategories]);

    // --- Translation Helper ---
    const getCategoryDisplayName = useCallback((categoryKey) => {
        return translations[categoryKey]?.[language] || categoryKey;
    }, [language]);

    // --- Canvas Drawing & Sizing ---
    const draw = useCallback(() => {
        const canvas = canvasRef.current;
        if (!canvas || !initialPanSet.current) return;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        const currentMap = Object.values(MAPS).find(m => m.id === currentMapId) || MAPS.jorvik;

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        ctx.save();
        ctx.translate(panX, panY);
        ctx.scale(scale, scale);

        if (isImageLoaded && mapImageRef.current.complete) {
            ctx.drawImage(mapImageRef.current, 0, 0, currentMap.width, currentMap.height);
        }

        const activePoi = pinnedPoi || selectedPoi;

        visiblePois.forEach(poi => {
            const isFoxPaw = poi.id.includes('fox-paw');

            ctx.globalAlpha = poi.isFound ? 0.3 : 1.0;

            if (isFoxPaw) {
                const size = 15 / scale;
                const px = poi.visualX;
                const py = poi.visualY;

                if (patouneImageRef.current.complete && patouneImageRef.current.naturalWidth !== 0) {
                    ctx.drawImage(patouneImageRef.current, px - size / 2, py - size / 2, size, size);
                } else {
                    // Fallback to previous drawing if image not loaded
                    ctx.fillStyle = poi.isFound ? 'grey' : 'white';
                    ctx.beginPath();
                    ctx.ellipse(px, py + size * 0.2, size * 0.4, size * 0.3, 0, 0, Math.PI * 2);
                    ctx.fill();
                    const toeSize = size * 0.18;
                    const toeOffsets = [{ x: -0.3, y: -0.2 }, { x: -0.1, y: -0.35 }, { x: 0.1, y: -0.35 }, { x: 0.3, y: -0.2 }];
                    toeOffsets.forEach(offset => {
                        ctx.beginPath();
                        ctx.arc(px + offset.x * size, py + offset.y * size, toeSize, 0, Math.PI * 2);
                        ctx.fill();
                    });
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.8 / (15 / 10), 0, Math.PI * 2); // Adjusted for slightly larger size
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 3 / scale;
                    ctx.stroke();
                }
            } else if (poi.id.includes('fox-food')) {
                const size = 15 / scale;
                const px = poi.visualX;
                const py = poi.visualY;

                if (myrtilleImageRef.current.complete && myrtilleImageRef.current.naturalWidth !== 0) {
                    ctx.drawImage(myrtilleImageRef.current, px - size / 2, py - size / 2, size, size);
                } else {
                    ctx.beginPath();
                    ctx.arc(px, py, 7 / scale, 0, Math.PI * 2);
                    ctx.fillStyle = poi.isFound ? 'grey' : '#63b3ed';
                    ctx.fill();
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.6, 0, Math.PI * 2);
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 3 / scale;
                    ctx.stroke();
                }
            } else if (poi.name && poi.name.fr === 'Abeille') {
                const size = 20 / scale;
                const px = poi.visualX;
                const py = poi.visualY;

                if (beeImageRef.current.complete && beeImageRef.current.naturalWidth !== 0) {
                    ctx.drawImage(beeImageRef.current, px - size / 2, py - size / 2, size, size);
                } else {
                    ctx.beginPath();
                    ctx.arc(px, py, 7 / scale, 0, Math.PI * 2);
                    ctx.fillStyle = poi.isFound ? 'grey' : '#f1c40f';
                    ctx.fill();
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.7, 0, Math.PI * 2);
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 3 / scale;
                    ctx.stroke();
                }
            } else if (poi.name && poi.name.fr === 'Doux Souvenirs') {
                const size = 18 / scale;
                const px = poi.visualX;
                const py = poi.visualY;

                if (alveoleImageRef.current.complete && alveoleImageRef.current.naturalWidth !== 0) {
                    ctx.drawImage(alveoleImageRef.current, px - size / 2, py - size / 2, size, size);
                } else {
                    ctx.beginPath();
                    ctx.arc(px, py, 7 / scale, 0, Math.PI * 2);
                    ctx.fillStyle = poi.isFound ? 'grey' : '#2fd4fd';
                    ctx.fill();
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.7, 0, Math.PI * 2);
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 3 / scale;
                    ctx.stroke();
                }
            } else if (poi.category === 'Erissa\'s Dolls') {
                const size = 18 / scale;
                const px = poi.visualX;
                const py = poi.visualY;

                if (dollImageRef.current.complete && dollImageRef.current.naturalWidth !== 0) {
                    ctx.drawImage(dollImageRef.current, px - size / 2, py - size / 2, size, size);
                } else {
                    ctx.beginPath();
                    ctx.arc(px, py, 7 / scale, 0, Math.PI * 2);
                    ctx.fillStyle = poi.isFound ? 'grey' : (categoryColors[poi.category] || '#ff4dc6');
                    ctx.fill();
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.7, 0, Math.PI * 2);
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 3 / scale;
                    ctx.stroke();
                }
            } else if (poi.category === 'Brissie\'s Adventures') {
                const size = 18 / scale;
                const px = poi.visualX;
                const py = poi.visualY;

                if (brissieImageRef.current.complete && brissieImageRef.current.naturalWidth !== 0) {
                    ctx.drawImage(brissieImageRef.current, px - size / 2, py - size / 2, size, size);
                } else {
                    ctx.beginPath();
                    ctx.arc(px, py, 7 / scale, 0, Math.PI * 2);
                    ctx.fillStyle = poi.isFound ? 'grey' : (categoryColors[poi.category] || '#90a0ad');
                    ctx.fill();
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.7, 0, Math.PI * 2);
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 3 / scale;
                    ctx.stroke();
                }
            } else if (poi.category === 'Spider') {
                const size = 18 / scale;
                const px = poi.visualX;
                const py = poi.visualY;

                if (spiderImageRef.current.complete && spiderImageRef.current.naturalWidth !== 0) {
                    ctx.drawImage(spiderImageRef.current, px - size / 2, py - size / 2, size, size);
                } else {
                    ctx.beginPath();
                    ctx.arc(px, py, 7 / scale, 0, Math.PI * 2);
                    ctx.fillStyle = poi.isFound ? 'grey' : (categoryColors[poi.category] || '#3498db');
                    ctx.fill();
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.7, 0, Math.PI * 2);
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 3 / scale;
                    ctx.stroke();
                }
            } else if (poi.category === 'Miniature Donkey') {
                const size = 18 / scale;
                const px = poi.visualX;
                const py = poi.visualY;
                const frName = poi.name && (typeof poi.name === 'string' ? poi.name : poi.name.fr) || '';

                let img = null;
                if (frName.includes('Déterminés')) {
                    img = shoe2ImageRef.current;
                } else if (frName.includes('Disparus')) {
                    img = shoeImageRef.current;
                }

                if (img && img.complete && img.naturalWidth !== 0) {
                    ctx.drawImage(img, px - size / 2, py - size / 2, size, size);
                } else {
                    ctx.beginPath();
                    ctx.arc(px, py, 7 / scale, 0, Math.PI * 2);
                    ctx.fillStyle = poi.isFound ? 'grey' : (categoryColors[poi.category] || '#2ecc71');
                    ctx.fill();
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.7, 0, Math.PI * 2);
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 3 / scale;
                    ctx.stroke();
                }
            } else if (poi.category === 'Fallen Star') {
                const size = 18 / scale;
                const px = poi.visualX;
                const py = poi.visualY;

                if (starImageRef.current.complete && starImageRef.current.naturalWidth !== 0) {
                    ctx.drawImage(starImageRef.current, px - size / 2, py - size / 2, size, size);
                } else {
                    ctx.beginPath();
                    ctx.arc(px, py, 7 / scale, 0, Math.PI * 2);
                    ctx.fillStyle = poi.isFound ? 'grey' : (categoryColors[poi.category] || '#f1c40f');
                    ctx.fill();
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.7, 0, Math.PI * 2);
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 3 / scale;
                    ctx.stroke();
                }
            } else if (poi.category === "Catherine's Memories") {
                const size = 18 / scale;
                const px = poi.visualX;
                const py = poi.visualY;
                const frName = poi.name && (typeof poi.name === 'string' ? poi.name : poi.name.fr || '') || '';

                let img = butterflyImageRef.current;
                if (frName.includes('Partie 2')) {
                    img = butterfly1ImageRef.current;
                } else if (frName.includes('Partie 3')) {
                    img = butterfly2ImageRef.current;
                } else if (frName.includes('Partie 4')) {
                    img = butterfly3ImageRef.current;
                }

                if (img && img.complete && img.naturalWidth !== 0) {
                    ctx.drawImage(img, px - size / 2, py - size / 2, size, size);
                } else {
                    ctx.beginPath();
                    ctx.arc(px, py, 7 / scale, 0, Math.PI * 2);
                    ctx.fillStyle = poi.isFound ? 'grey' : (categoryColors[poi.category] || '#9b59b6');
                    ctx.fill();
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.7, 0, Math.PI * 2);
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 3 / scale;
                    ctx.stroke();
                }
            } else if (poi.category === "Toy Postcard") {
                const size = 18 / scale;
                const px = poi.visualX;
                const py = poi.visualY;

                const frName = poi.name && (typeof poi.name === 'string' ? poi.name : poi.name.fr) || '';
                let currentFlameImage = flameImageRef.current;

                if (frName.startsWith('Partie 2')) {
                    currentFlameImage = flame2ImageRef.current;
                } else if (frName.startsWith('Partie 3')) {
                    currentFlameImage = flame3ImageRef.current;
                } else if (frName.startsWith('Partie 4')) {
                    currentFlameImage = flame4ImageRef.current;
                } else if (frName.startsWith('Partie 5')) {
                    currentFlameImage = flame5ImageRef.current;
                } else if (frName.startsWith('Partie 6')) {
                    currentFlameImage = flame6ImageRef.current;
                }

                if (currentFlameImage.complete && currentFlameImage.naturalWidth !== 0) {
                    ctx.drawImage(currentFlameImage, px - size / 2, py - size / 2, size, size);
                } else {
                    ctx.beginPath();
                    ctx.arc(px, py, 7 / scale, 0, Math.PI * 2);
                    ctx.fillStyle = poi.isFound ? 'grey' : (categoryColors[poi.category] || '#e74c3c');
                    ctx.fill();
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.7, 0, Math.PI * 2);
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 3 / scale;
                    ctx.stroke();
                }
            } else if (poi.category === "Archaeology VHD") {
                const size = 18 / scale;
                const px = poi.visualX;
                const py = poi.visualY;
                const frName = poi.name && (typeof poi.name === 'string' ? poi.name : poi.name.fr) || '';

                let img = null;
                if (frName.includes('Petit Dinosaure')) {
                    img = smallDinoImageRef.current;
                } else if (frName.includes('inhabituel')) {
                    img = uncommonDinoImageRef.current;
                } else if (frName.includes('spectaculaire')) {
                    img = spectacularDinoImageRef.current;
                } else if (frName.includes('mystérieux')) {
                    img = mysticalDinoImageRef.current;
                }

                if (img && img.complete && img.naturalWidth !== 0) {
                    ctx.drawImage(img, px - size / 2, py - size / 2, size, size);
                } else {
                    ctx.beginPath();
                    ctx.arc(px, py, 7 / scale, 0, Math.PI * 2);
                    ctx.fillStyle = poi.isFound ? 'grey' : (categoryColors[poi.category] || '#7f8c8d');
                    ctx.fill();
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.7, 0, Math.PI * 2);
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 3 / scale;
                    ctx.stroke();
                }
            } else if (poi.category === "Archaeology Epona") {
                const size = 18 / scale;
                const px = poi.visualX;
                const py = poi.visualY;
                const frName = poi.name && (typeof poi.name === 'string' ? poi.name : poi.name.fr || '') || '';

                let img = null;
                if (frName.includes('Viking')) {
                    img = vikingSwordImageRef.current;
                } else if (frName.includes('Coutellerie')) {
                    img = cutleryImageRef.current;
                } else if (frName.includes('Longue-vue')) {
                    img = spyglassImageRef.current;
                } else if (frName.includes('Amphore')) {
                    img = amphoraImageRef.current;
                }

                if (img && img.complete && img.naturalWidth !== 0) {
                    ctx.drawImage(img, px - size / 2, py - size / 2, size, size);
                } else {
                    ctx.beginPath();
                    ctx.arc(px, py, 7 / scale, 0, Math.PI * 2);
                    ctx.fillStyle = poi.isFound ? 'grey' : (categoryColors[poi.category] || '#95a5a6');
                    ctx.fill();
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.7, 0, Math.PI * 2);
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 3 / scale;
                    ctx.stroke();
                }
            } else if (poi.category === "Secret Quest Fox") {
                const size = 18 / scale;
                const px = poi.visualX;
                const py = poi.visualY;
                const frName = poi.name && (typeof poi.name === 'string' ? poi.name : poi.name.fr || '') || '';

                let img = null;
                const weekdaysFox1 = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

                if (weekdaysFox1.some(day => frName.includes(day))) {
                    img = fox1ImageRef.current;
                } else if (frName.includes('Dimanche')) {
                    img = fox2ImageRef.current;
                }

                if (img && img.complete && img.naturalWidth !== 0) {
                    ctx.drawImage(img, px - size / 2, py - size / 2, size, size);
                } else {
                    ctx.beginPath();
                    ctx.arc(px, py, 7 / scale, 0, Math.PI * 2);
                    ctx.fillStyle = poi.isFound ? 'grey' : (categoryColors[poi.category] || '#ff9c00');
                    ctx.fill();

                    ctx.strokeStyle = poi.strokeColor || 'white';
                    ctx.lineWidth = 2 / scale;
                    ctx.stroke();
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.7, 0, Math.PI * 2);
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 4 / scale;
                    ctx.stroke();
                }
            } else if (poi.category === "Plantes") {
                const size = 18 / scale;
                const px = poi.visualX;
                const py = poi.visualY;
                const frName = poi.name && (typeof poi.name === 'string' ? poi.name : poi.name.fr || '') || '';

                let img = null;
                if (frName.includes('Jute')) {
                    img = juteImageRef.current;
                } else if (frName.includes('Lin')) {
                    img = linImageRef.current;
                } else if (frName.includes('Garance')) {
                    img = garanceImageRef.current;
                } else if (frName.includes('Camomille')) {
                    img = camomilleImageRef.current;
                } else if (frName.includes('Monarde')) {
                    img = monardeImageRef.current;
                } else if (frName.includes('Mousse')) {
                    img = mousseImageRef.current;
                }

                if (img && img.complete && img.naturalWidth !== 0) {
                    ctx.drawImage(img, px - size / 2, py - size / 2, size, size);
                } else {
                    ctx.beginPath();
                    ctx.arc(px, py, 7 / scale, 0, Math.PI * 2);
                    ctx.fillStyle = poi.isFound ? 'grey' : (categoryColors[poi.category] || '#2ecc71');
                    ctx.fill();
                }

                if (activePoi && activePoi.id === poi.id) {
                    ctx.beginPath();
                    ctx.arc(px, py, size * 0.7, 0, Math.PI * 2);
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 3 / scale;
                    ctx.stroke();
                }
            } else {
                ctx.beginPath();
                ctx.arc(poi.visualX, poi.visualY, 7 / scale, 0, Math.PI * 2);
                ctx.fillStyle = poi.isFound ? 'grey' : (categoryColors[poi.category] || '#34495e');
                ctx.fill();

                let stroke = poi.strokeColor || 'white';
                if (poi.name && poi.name.fr) {
                    const frName = poi.name.fr.toLowerCase();
                    if (frName.includes('doux souvenirs')) {
                        stroke = '#2fd4fd';
                    } else if (frName.includes('abeille') && !poi.strokeColor) {
                        stroke = '#d99947';
                    }
                }
                ctx.strokeStyle = stroke;
                ctx.lineWidth = 2 / scale;
                if (activePoi && activePoi.id === poi.id) {
                    ctx.strokeStyle = '#63b3ed';
                    ctx.lineWidth = 4 / scale;
                }
                ctx.stroke();
            }
        });

        ctx.restore();
    }, [scale, panX, panY, visiblePois, categoryColors, selectedPoi, pinnedPoi, isImageLoaded, currentMapId]);


    // Reset initial pan ONLY when map changes
    useEffect(() => {
        initialPanSet.current = false;
        setIsImageLoaded(false);
    }, [currentMapId]);

    useEffect(() => {
        const canvas = canvasRef.current;
        const image = mapImageRef.current;
        const currentMap = Object.values(MAPS).find(m => m.id === currentMapId) || MAPS.jorvik;

        let retryCount = 0;
        const maxRetries = 10;

        const handleLoadOrResize = () => {
            if (!canvas) return;

            // Critical check: if canvas has no size, retry after a short delay
            if (canvas.offsetWidth === 0 && retryCount < maxRetries) {
                retryCount++;
                setTimeout(handleLoadOrResize, 100);
                return;
            }

            canvas.width = canvas.offsetWidth;
            canvas.height = canvas.offsetHeight;

            if (!initialPanSet.current && canvas.width > 0 && image.complete && image.naturalWidth !== 0) {
                const scaleX = canvas.width / currentMap.width;
                const scaleY = canvas.height / currentMap.height;
                const newScale = Math.min(scaleX, scaleY) * 0.9;
                setScale(newScale);
                setPanX((canvas.width - currentMap.width * newScale) / 2);
                setPanY((canvas.height - currentMap.height * newScale) / 2);
                initialPanSet.current = true;
                setIsImageLoaded(true);
            }
            draw();
        };

        image.onload = handleLoadOrResize;
        image.onerror = () => {
            console.error("Failed to load image:", currentMap.file);
            setIsImageLoaded(false);
            if (!initialPanSet.current && canvas) {
                if (canvas.offsetWidth === 0 && retryCount < maxRetries) {
                    retryCount++;
                    setTimeout(handleLoadOrResize, 100);
                    return;
                }
                canvas.width = canvas.offsetWidth;
                canvas.height = canvas.offsetHeight;
                const newScale = Math.min(canvas.width / currentMap.width, canvas.height / currentMap.height) * 0.9;
                setScale(newScale);
                setPanX((canvas.width - currentMap.width * newScale) / 2);
                setPanY((canvas.height - currentMap.height * newScale) / 2);
                initialPanSet.current = true;
            }
            draw();
        };

        let mapFile = currentMap.file;
        if (mapMode === 'bw') {
            if (currentMap.id === 'jorvik') mapFile = 'map sso sombre.png';
            else if (currentMap.id === 'winter-village') mapFile = "village d'hivers nb.jpg";
            else if (currentMap.id === 'governors-fall') mapFile = 'map la chute du gouverneur nb.jpg';
            else if (currentMap.id === 'aideens-plaza') mapFile = "map la place d'aideen nb.jpg";
            else if (currentMap.id === 'jorvik-city-gallery') mapFile = 'map Galerie Jorvik City nb.jpg';
            else if (currentMap.id === 'pier-13') mapFile = 'map quai 13 nb.jpg';
            else if (currentMap.id === 'pandoria') mapFile = 'map pandoria nb.jpg';
        }
        image.src = mapFile;

        if (image.complete && image.naturalWidth !== 0) {
            handleLoadOrResize();
        }

        window.addEventListener('resize', handleLoadOrResize);
        return () => {
            window.removeEventListener('resize', handleLoadOrResize);
        };
    }, [currentMapId, mapMode, draw]); // Re-added draw to be safe, but logic inside draw handles initialPanSet.current

    // Trigger a synthetic resize after app mounts to ensure map centers on initial load (bypassing CSS/mobile layout jank)
    useEffect(() => {
        const timer = setTimeout(() => {
            initialPanSet.current = false;
            window.dispatchEvent(new Event('resize'));
        }, 500);
        return () => clearTimeout(timer);
    }, [currentMapId]);

    useEffect(() => { draw(); }, [draw]);

    // --- Event Handlers ---
    const getEventCoordinates = (e) => { if (e.touches && e.touches.length > 0) { return { x: e.touches[0].clientX, y: e.touches[0].clientY }; } return { x: e.clientX, y: e.clientY }; }
    const screenToWorld = useCallback((screenX, screenY) => { const canvas = canvasRef.current; if (!canvas) return { x: 0, y: 0 }; const rect = canvas.getBoundingClientRect(); const worldX = (screenX - rect.left - panX) / scale; const worldY = (screenY - rect.top - panY) / scale; return { x: worldX, y: worldY }; }, [panX, panY, scale]);

    const handleDragStart = (e) => {
        if (e.touches && e.touches.length === 2) {
            e.preventDefault();
            setIsPinching(true);
            pinchDist.current = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
        } else {
            setIsDragging(true);
            const coords = getEventCoordinates(e);
            dragStartPos.current = coords;
            setLastMousePos(coords);
            if (canvasRef.current) canvasRef.current.style.cursor = 'grabbing';
        }
    };

    const handleDragEnd = (e) => {
        if (isPinching) setIsPinching(false);
        if (isDragging) setIsDragging(false);
        if (canvasRef.current) canvasRef.current.style.cursor = 'grab';
    };

    const handleMouseMove = (e) => {
        if (isPinching && e.touches && e.touches.length === 2) {
            e.preventDefault();
            const newDist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
            const currentMap = Object.values(MAPS).find(m => m.id === currentMapId) || MAPS.jorvik;
            const newScale = scale * (newDist / pinchDist.current);
            const clampedScale = Math.max(0.1, Math.min(currentMap.maxScale, newScale));

            const rect = canvasRef.current.getBoundingClientRect();
            const midX = (e.touches[0].clientX + e.touches[1].clientX) / 2 - rect.left;
            const midY = (e.touches[0].clientY + e.touches[1].clientY) / 2 - rect.top;
            const worldX = (midX - panX) / scale;
            const worldY = (midY - panY) / scale;

            setPanX(midX - worldX * clampedScale);
            setPanY(midY - worldY * clampedScale);
            setScale(clampedScale);
            pinchDist.current = newDist;
        } else if (isDragging) {
            const coords = getEventCoordinates(e);
            const dx = coords.x - lastMousePos.x;
            const dy = coords.y - lastMousePos.y;
            setPanX(prev => prev + dx);
            setPanY(prev => prev + dy);
            setLastMousePos(coords);
        } else if (isDesktop) {
            const { x: clientX, y: clientY } = getEventCoordinates(e);
            const { x: worldX, y: worldY } = screenToWorld(clientX, clientY);
            let foundPoi = null;
            for (let i = visiblePois.length - 1; i >= 0; i--) {
                const poi = visiblePois[i];
                const dx = worldX - poi.visualX;
                const dy = worldY - poi.visualY;
                const hoverRadius = 15 / scale;
                if (Math.sqrt(dx * dx + dy * dy) < hoverRadius) {
                    foundPoi = poi;
                    break;
                }
            }
            if (foundPoi?.id !== selectedPoi?.id) { setSelectedPoi(foundPoi); }
        }
    };

    const handleWheel = (e) => {
        e.preventDefault();
        const canvas = canvasRef.current; if (!canvas) return;
        const currentMap = Object.values(MAPS).find(m => m.id === currentMapId) || MAPS.jorvik;
        const zoomFactor = 1.1; const rect = canvas.getBoundingClientRect();
        const mouseX = e.clientX - rect.left; const mouseY = e.clientY - rect.top;
        const newScale = e.deltaY < 0 ? scale * zoomFactor : scale / zoomFactor;
        const clampedScale = Math.max(0.1, Math.min(currentMap.maxScale, newScale));
        const worldX = (mouseX - panX) / scale; const worldY = (mouseY - panY) / scale;
        setPanX(mouseX - worldX * clampedScale); setPanY(mouseY - worldY * clampedScale);
        setScale(clampedScale);
    };

    const handleCanvasClick = useCallback((e) => {
        const { x: clientX, y: clientY } = getEventCoordinates(e.nativeEvent);
        if ((isDragging || isPinching) && (Math.abs(clientX - dragStartPos.current.x) > 5 || Math.abs(clientY - dragStartPos.current.y) > 5)) return;
        const { x: clickWorldX, y: clickWorldY } = screenToWorld(clientX, clientY);
        let clickedPoi = null;
        for (let i = visiblePois.length - 1; i >= 0; i--) {
            const poi = visiblePois[i];
            const dx = clickWorldX - poi.visualX;
            const dy = clickWorldY - poi.visualY;
            if (Math.sqrt(dx * dx + dy * dy) < (15 / scale)) {
                clickedPoi = poi;
                break;
            }
        }
        if (clickedPoi) {
            // Toggle closed if already selected
            if (pinnedPoi && pinnedPoi.id === clickedPoi.id) {
                setPinnedPoi(null);
                return;
            }

            if (isDesktop) {
                if (clickedPoi.id.startsWith('custom-poi-')) {
                    setPinnedPoi(clickedPoi);
                } else {
                    setPois(prevPois => prevPois.map(p => p.id === clickedPoi.id ? { ...p, isFound: !p.isFound } : p));
                    setPinnedPoi(null);
                }
            } else {
                setPinnedPoi(clickedPoi);
            }
        } else {
            setPinnedPoi(null);
        }
    }, [visiblePois, screenToWorld, scale, isDesktop, isDragging, isPinching]);

    // --- POI & Category Management Handlers ---
    const handleToggleFound = (poiId) => {
        setPois(prevPois => prevPois.map(p => p.id === poiId ? { ...p, isFound: !p.isFound } : p));
        setPinnedPoi(prev => (prev && prev.id === poiId ? { ...prev, isFound: !prev.isFound } : prev));

        // Auto-close popup on mobile after a short delay for UX
        if (!isDesktop) {
            setTimeout(() => {
                setPinnedPoi(null);
            }, 200);
        }
    };

    const handleDeletePoi = (poiIdToDelete) => { setModal({ isVisible: true, message: translations.confirmDeletePoi[language], showCancel: true, onConfirm: () => { setPois(prevPois => prevPois.filter(p => p.id !== poiIdToDelete)); setPinnedPoi(null); setModal({ ...modal, isVisible: false }); }, onCancel: () => setModal({ ...modal, isVisible: false }), }); };
    const handleClosePopup = (e) => { e.stopPropagation(); setPinnedPoi(null); };

    const handleUpdateCategory = (oldName, newName, newColor) => {
        const trimmedNewName = newName.trim();
        if (!trimmedNewName) { setModal({ isVisible: true, message: translations.categoryNameEmpty[language], onConfirm: () => setModal({ ...modal, isVisible: false }) }); return; }
        if (trimmedNewName !== oldName && Object.keys(categoryColors).includes(trimmedNewName)) { setModal({ isVisible: true, message: translations.categoryExistsError[language](trimmedNewName), onConfirm: () => setModal({ ...modal, isVisible: false }) }); return; }

        setCategoryColors(prevColors => { const newColors = { ...prevColors }; if (oldName !== trimmedNewName) { delete newColors[oldName]; } newColors[trimmedNewName] = newColor; return newColors; });
        if (oldName !== trimmedNewName) { setPois(prevPois => prevPois.map(p => (p.category === oldName ? { ...p, category: trimmedNewName } : p))); }
    };

    const handleDeleteCategory = (categoryToDelete) => {
        const categoryDisplayName = getCategoryDisplayName(categoryToDelete);
        setModal({
            isVisible: true,
            message: translations.confirmDeleteCategory[language](categoryDisplayName),
            showCancel: true,
            onConfirm: () => {
                setPois(prevPois => prevPois.filter(p => p.category !== categoryToDelete));
                setCategoryColors(prev => { const newColors = { ...prev }; delete newColors[categoryToDelete]; return newColors; });
                setSelectedCategories(prev => { const newSelection = new Set(prev); newSelection.delete(categoryToDelete); return newSelection; });
                setModal({ ...modal, isVisible: false });
            },
            onCancel: () => setModal({ ...modal, isVisible: false })
        });
    };

    const handleCategorySelectionChange = (category) => { const newSelection = new Set(selectedCategories); if (newSelection.has(category)) { newSelection.delete(category); } else { newSelection.add(category); } setSelectedCategories(newSelection); };
    const handleNewPoiChange = (e) => {
        const { name, value } = e.target;
        setNewPoi(prev => ({ ...prev, [name]: value }));
    };

    const handleCategoryChange = (e) => {
        const value = e.target.value;
        if (value === "___CREATE_NEW___") {
            setShowNewCategoryInput(true);
            setNewPoi(prev => ({ ...prev, category: '' }));
        } else {
            setShowNewCategoryInput(false);
            setNewPoi(prev => ({ ...prev, category: value }));
        }
    };

    const handleAddPoi = () => {
        let finalCategory = newPoi.category;
        if (showNewCategoryInput) {
            if (!newCategoryName) {
                setModal({ isVisible: true, message: translations.newCategoryNameEmptyError[language], onConfirm: () => setModal({ ...modal, isVisible: false }) });
                return;
            }
            finalCategory = newCategoryName.trim();
            if (!Object.keys(categoryColors).includes(finalCategory)) {
                setCategoryColors(prev => ({ ...prev, [finalCategory]: newCategoryColor }));
            }
        }
        if (!newPoi.x || !newPoi.y || !newPoi.name || !finalCategory) {
            setModal({ isVisible: true, message: translations.fillFieldsError[language], onConfirm: () => setModal({ ...modal, isVisible: false }) });
            return;
        }
        const poiToAdd = {
            id: `custom-poi-${Date.now()}`, x: parseFloat(newPoi.x), y: parseFloat(newPoi.y),
            name: { en: newPoi.name, fr: newPoi.name },
            category: finalCategory, notes: { en: newPoi.notes_en, fr: newPoi.notes_fr },
            isFound: false, mapId: currentMapId
        };
        setPois(prev => [...prev, poiToAdd]);
        setNewPoi({ x: '', y: '', name: '', category: '', notes_en: '', notes_fr: '' });
        setShowNewCategoryInput(false); setNewCategoryName(''); setNewCategoryColor('#ffffff');
    };

    // --- Render ---
    const activePoi = pinnedPoi || (!isPinching && selectedPoi);
    const showToggleButton = activePoi && (activePoi.id.startsWith('custom-poi-') || !isDesktop);
    const showDeleteButton = activePoi && activePoi.id.startsWith('custom-poi-');

    if (pois.length === 0) return <div className="loadingScreen"><div className="loadingText">{translations.loadingMap[language]}</div></div>;

    const customCategories = allCategories.filter(cat => !BUILT_IN_CATEGORIES.includes(cat) && cat);

    return (
        <div className="appContainer">
            <div className="topBar">
                <div className="topBar-item-sso">
                    <img
                        src={isDesktop ? "sso_title_logo.png" : "sso_title_logo_phone.png"}
                        alt={translations.ssoTitleAlt[language]}
                        className="titleImage"
                    />
                </div>
                <div className="topBar-item-dzaka">
                    <a href="https://www.dzaka.fr/" target="_blank" rel="noopener noreferrer" className="logoLink">
                        <img
                            src={isDesktop ? "sso_dzaka2.png" : "sso_dzaka2_phone.png"}
                            alt={translations.dzakaLogoAlt[language]}
                            className="logoImage"
                        />
                    </a>
                </div>

                <div className="topBar-item-language">
                    <div className="languageControls">
                        <div className="controlGroup">
                            <label htmlFor="mapSelect" className="languageLabel">{translations.mapLabel[language]}</label>
                            <select id="mapSelect" className="controlSelect" value={currentMapId} onChange={(e) => { setCurrentMapId(e.target.value); initialPanSet.current = false; setPinnedPoi(null); }}>
                                {Object.values(MAPS).map(m => (
                                    <option key={m.id} value={m.id}>{translations[m.nameKey][language]}</option>
                                ))}
                            </select>
                        </div>
                        <div className="controlGroup">
                            <label htmlFor="modeSelect" className="languageLabel">{translations.modeLabel[language]}</label>
                            <select id="modeSelect" className="controlSelect" value={mapMode} onChange={(e) => { setMapMode(e.target.value); }}>
                                <option value="color">{translations.modeColor[language]}</option>
                                <option value="bw">{translations.modeBW[language]}</option>
                            </select>
                        </div>
                        <div className="controlGroup">
                            <label htmlFor="languageSelect" className="languageLabel">{translations.languageLabel[language]}</label>
                            <select id="languageSelect" className="controlSelect" value={language} onChange={(e) => setLanguage(e.target.value)}>
                                <option value="fr">Français</option>
                                <option value="en">English</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <canvas
                ref={canvasRef} className="mapCanvas"
                onMouseDown={handleDragStart} onMouseMove={handleMouseMove} onMouseUp={handleDragEnd} onMouseLeave={handleDragEnd}
                onTouchStart={handleDragStart} onTouchMove={handleMouseMove} onTouchEnd={handleDragEnd}
                onClick={handleCanvasClick} onWheel={handleWheel}
            />

            <div className={`addPoiForm ${isPoiFormMinimized ? 'minimized' : ''}`}>
                <div className="addPoiHeader" onClick={() => { setIsPoiFormMinimized(!isPoiFormMinimized); setPinnedPoi(null); }}>
                    <h3 className="addPoiTitle">{translations.addPoiTitle[language]}</h3>
                    <span className="toggleButton">{isPoiFormMinimized ? '+' : '-'}</span>
                </div>
                <div className="formContent">
                    <div className="formGrid">
                        <input type="number" name="x" placeholder={translations.xCoordPlaceholder[language]} value={newPoi.x} onChange={handleNewPoiChange} className="formInput" />
                        <input type="number" name="y" placeholder={translations.yCoordPlaceholder[language]} value={newPoi.y} onChange={handleNewPoiChange} className="formInput" />
                        <input type="text" name="name" placeholder={translations.poiNamePlaceholder[language]} value={newPoi.name} onChange={handleNewPoiChange} className="formInput" />
                        <select name="category" value={showNewCategoryInput ? '___CREATE_NEW___' : newPoi.category} onChange={handleCategoryChange} className="formSelect">
                            <option value="" disabled>{translations.selectCategory[language]}</option>
                            {allCategories.map(cat => cat && <option key={cat} value={cat}>{getCategoryDisplayName(cat)}</option>)}
                            <option value="___CREATE_NEW___">{translations.createNewCategory[language]}</option>
                        </select>
                        {showNewCategoryInput && (
                            <div className="newCategoryContainer">
                                <input type="text" placeholder={translations.newCategoryNamePlaceholder[language]} value={newCategoryName} onChange={(e) => setNewCategoryName(e.target.value)} className="formInput" />
                                <input type="color" value={newCategoryColor} onChange={(e) => setNewCategoryColor(e.target.value)} className="colorPicker" title={translations.colorPickerTitle[language]} />
                            </div>
                        )}
                        <textarea name="notes_fr" placeholder={translations.notesFrPlaceholder[language]} value={newPoi.notes_fr} onChange={handleNewPoiChange} rows="2" className="formInput"></textarea>
                        <textarea name="notes_en" placeholder={translations.notesEnPlaceholder[language]} value={newPoi.notes_en} onChange={handleNewPoiChange} rows="2" className="formInput"></textarea>
                    </div>
                    <button onClick={handleAddPoi} className="addButton">{translations.addPoiButton[language]}</button>
                </div>
            </div>

            <div className={`filterPanel ${isFilterMinimized ? 'minimized' : ''}`}>
                <div className="filterPanelHeader" onClick={() => setIsFilterMinimized(!isFilterMinimized)}>
                    <h3>{translations.filterCategoriesTitle[language]}</h3>
                    <div className="filterHeaderActions">
                        <button className="manageButton" title={translations.manageButton[language]} onClick={(e) => { e.stopPropagation(); setIsCategoryManagerOpen(true); }}>{translations.manageButton[language]}</button>
                        <span className="toggleButton">{isFilterMinimized ? '+' : '-'}</span>
                    </div>
                </div>
                <div className="filterContent">
                    <div className="categoryFilterContainer">
                        {allCategories.map(cat => cat && (
                            <div key={cat} className="categoryItemWrapper">
                                <label className="categoryCheckbox">
                                    <input type="checkbox" checked={selectedCategories.has(cat)} onChange={() => handleCategorySelectionChange(cat)} />
                                    {CATEGORY_ICONS[cat] ? (
                                        <img src={CATEGORY_ICONS[cat]} alt={cat} className="categoryIcon" />
                                    ) : (
                                        <span className="categoryColorSquare" style={{ color: categoryColors[cat] || '#34495e' }}>■</span>
                                    )}
                                    {getCategoryDisplayName(cat)}
                                </label>
                                {['Secret Quest Fox', 'Toy Postcard', "Catherine's Memories", "Miniature Donkey", "Archaeology VHD", 'Secret Quest Bee', 'Archaeology Epona', 'Plantes'].includes(cat) && (
                                    <span
                                        className="foxTooltipIcon"
                                        onClick={(e) => {
                                            if (!isDesktop) {
                                                if (activeTooltip && activeTooltip.cat === cat) {
                                                    setActiveTooltip(null);
                                                } else {
                                                    const rect = e.target.getBoundingClientRect();
                                                    const isBottomHalf = rect.top > window.innerHeight / 2;
                                                    setActiveTooltip({
                                                        cat,
                                                        x: rect.left,
                                                        yPos: isBottomHalf ? Math.max(10, window.innerHeight - rect.bottom) : Math.max(10, rect.top),
                                                        isBottomHalf
                                                    });
                                                }
                                            }
                                        }}
                                        onMouseEnter={(e) => {
                                            if (isDesktop) {
                                                const rect = e.target.getBoundingClientRect();
                                                const isBottomHalf = rect.top > window.innerHeight / 2;
                                                setActiveTooltip({
                                                    cat,
                                                    x: rect.left,
                                                    yPos: isBottomHalf ? Math.max(10, window.innerHeight - rect.bottom) : Math.max(10, rect.top),
                                                    isBottomHalf
                                                });
                                            }
                                        }}
                                        onMouseLeave={() => {
                                            if (isDesktop) setActiveTooltip(null);
                                        }}
                                    >
                                        ?
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>

                </div>
            </div>


            {activePoi && !isDesktop && <div className="popupOverlay" onClick={handleClosePopup}></div>}
            {activePoi && (<div className="selectedPoiPopup" style={isDesktop ? { left: `min(calc(100vw - 300px), ${(((activePoi.visualX || (activePoi.x + (Object.values(MAPS).find(m => m.id === currentMapId)?.offsetX || 0))) * scale + panX) + 20)}px)`, top: `min(calc(100vh - 200px), ${(((activePoi.visualY || (activePoi.y + (Object.values(MAPS).find(m => m.id === currentMapId)?.offsetY || 0))) * scale + panY))}px)` } : {}}> <div className="popupHeader"> <h4 className="popupTitle">{activePoi.name[language]}</h4> {/* MODIFIED: Access name by language */} <button className="popupCloseButton" onClick={handleClosePopup}>&times;</button> </div> <div className="popupContent"> <p><b>{translations.popupCategoryLabel[language]}</b> <span style={{ color: categoryColors[activePoi.category] || '#34495e', fontWeight: 'bold' }}>{getCategoryDisplayName(activePoi.category)}</span></p> <p>{typeof activePoi.notes === 'object' && activePoi.notes ? activePoi.notes[language] : (activePoi.notes || translations.noDescription[language])}</p> <p className="popupCoords">({activePoi.x?.toFixed(0)}, {activePoi.y?.toFixed(0)})</p> </div> {(showToggleButton || showDeleteButton) && (<div className="popupActions"> {showToggleButton && (<button className="popupActionButton toggleFoundButton" onClick={() => handleToggleFound(activePoi.id)}> {activePoi.isFound ? translations.markAsUnfound[language] : translations.markAsFound[language]} </button>)} {showDeleteButton && (<button className="popupActionButton deleteButton" onClick={() => handleDeletePoi(activePoi.id)}>{translations.deleteButton[language]}</button>)} </div>)} </div>)}

            {isCategoryManagerOpen && <CategoryManagerModal customCategories={customCategories} categoryColors={categoryColors} onClose={() => setIsCategoryManagerOpen(false)} onUpdate={handleUpdateCategory} onDelete={handleDeleteCategory} language={language} />}
            {modal.isVisible && <CustomModal {...modal} language={language} />}
            {activeTooltip && (
                <div
                    className="foxTooltipContent"
                    style={{
                        position: 'fixed',
                        ...(activeTooltip.isBottomHalf ? { bottom: `${activeTooltip.yPos}px` } : { top: `${activeTooltip.yPos}px` }),
                        left: `${activeTooltip.x - 10}px`,
                        transform: 'translate(-100%, 0)',
                        zIndex: 1000,
                        maxHeight: 'calc(100vh - 20px)',
                        overflowY: 'auto'
                    }}
                >
                    {activeTooltip.cat === 'Secret Quest Fox' && (
                        <>
                            <p><strong>{language === 'en' ? 'Start and End Point:' : 'Point de départ et d\'arrivé :'}</strong> <span className="foxArrivalPoint"></span></p>
                            <p><strong>{language === 'en' ? 'Foxes to find:' : 'Renards à trouver :'}</strong> <img src="renard1.png" alt="Renard" className="foxTooltipImg" /> <img src="renard2.png" alt="Renard" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Hidden Foxes (Friday quest):' : 'Renards Cachés (quête vendredi) :'}</strong> <img src="patoune.png" alt="Patoune" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Food (Sunday quest):' : 'Nourriture (quête dimanche) :'}</strong> <img src="myrtille2.png" alt="Myrtille" className="foxTooltipImg" /></p>
                        </>
                    )}
                    {activeTooltip.cat === 'Toy Postcard' && (
                        <>
                            <p><strong>{language === 'en' ? 'Part 1:' : 'Partie 1 :'}</strong> <img src="flamme.png" alt="Part 1" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Part 2:' : 'Partie 2 :'}</strong> <img src="flamme2.png" alt="Part 2" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Part 3:' : 'Partie 3 :'}</strong> <img src="flamme3.png" alt="Part 3" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Part 4:' : 'Partie 4 :'}</strong> <img src="flamme4.png" alt="Part 4" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Part 5:' : 'Partie 5 :'}</strong> <img src="flamme5.png" alt="Part 5" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Part 6:' : 'Partie 6 :'}</strong> <img src="flamme6.png" alt="Part 6" className="foxTooltipImg" /></p>
                        </>
                    )}
                    {activeTooltip.cat === "Catherine's Memories" && (
                        <>
                            <p><strong>{language === 'en' ? 'Part 1:' : 'Partie 1 :'}</strong> <img src="papillion.png" alt="Part 1" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Part 2:' : 'Partie 2 :'}</strong> <img src="papillion1.png" alt="Part 2" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Part 3:' : 'Partie 3 :'}</strong> <img src="papillion2.png" alt="Part 3" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Part 4:' : 'Partie 4 :'}</strong> <img src="papillion3.png" alt="Part 4" className="foxTooltipImg" /></p>
                        </>
                    )}
                    {activeTooltip.cat === "Miniature Donkey" && (
                        <>
                            <p><strong>{language === 'en' ? 'Disappearing Donkeys:' : 'Ânes Disparus :'}</strong> <img src="fer a cheval.png" alt="Disparus" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Determined Disappearing Donkeys:' : 'Ânes Disparus Déterminés :'}</strong> <img src="fer a cheval2.png" alt="Déterminés" className="foxTooltipImg" /></p>
                        </>
                    )}
                    {activeTooltip.cat === "Archaeology VHD" && (
                        <>
                            <p><strong>{language === 'en' ? 'Small Skeleton:' : 'Petit Dinosaure :'}</strong> <img src="petit dino.png" alt="Petit" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Unusual Skeleton:' : 'Dinosaure Inhabituel :'}</strong> <img src="dino peu commun.png" alt="Inhabituel" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Spectacular Skeleton:' : 'Dinosaure Spectaculaire :'}</strong> <img src="dino spectaculaire.png" alt="Spectaculaire" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Mystical Skeleton:' : 'Dinosaure Mystérieux :'}</strong> <img src="dino mystique.png" alt="Mystérieux" className="foxTooltipImg" /></p>
                        </>
                    )}
                    {activeTooltip.cat === "Secret Quest Bee" && (
                        <>
                            <p><strong>{language === 'en' ? 'Starting point of the quest:' : 'Point de départ de la quête :'}</strong> <span className="beeArrivalPoint" style={{ display: 'inline-block', width: '14px', height: '14px', borderRadius: '50%', backgroundColor: '#cbff4d', border: '2px solid red', verticalAlign: 'middle', margin: '0 4px' }}></span></p>
                            <p><strong>{language === 'en' ? 'Bee (first part):' : 'Abeille (première partie) :'}</strong> <img src="abeille.png" alt="Abeille" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Sweet Memories (second part):' : 'Doux Souvenirs (seconde partie) :'}</strong> <img src="alveoles.png" alt="Doux Souvenirs" className="foxTooltipImg" /></p>
                        </>
                    )}
                    {activeTooltip.cat === "Archaeology Epona" && (
                        <>
                            <p><strong>{language === 'en' ? 'Spyglass Items:' : 'Longue-Vue :'}</strong> <img src="longue vue.png" alt="Longue-Vue" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Roman Amphora:' : 'Amphore Romain :'}</strong> <img src="amphore romain.png" alt="Amphore" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Cutlery Items:' : 'Ensemble Coutellerie :'}</strong> <img src="fourchette.png" alt="Coutellerie" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Viking Sword:' : 'Épée Viking :'}</strong> <img src="epee viking.png" alt="Viking" className="foxTooltipImg" /></p>
                        </>
                    )}
                    {activeTooltip.cat === "Plantes" && (
                        <>
                            <p><strong>{language === 'en' ? 'Flax:' : 'Lin :'}</strong> <img src="lin.png" alt="Lin" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Chamomile:' : 'Camomille :'}</strong> <img src="camomille.png" alt="Camomille" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Rubia:' : 'Garance des Teinturiers :'}</strong> <img src="garance des teinturiers.png" alt="Garance des Teinturiers" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Bee Balm:' : 'Monarde :'}</strong> <img src="monarde.png" alt="Monarde" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Moss:' : 'Mousse :'}</strong> <img src="mousse.png" alt="Mousse" className="foxTooltipImg" /></p>
                            <p><strong>{language === 'en' ? 'Jute:' : 'Jute :'}</strong> <img src="jute.png" alt="Jute" className="foxTooltipImg" /></p>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default App;